import $ from "jquery";

export const eventHideNavMobileIcon = () => {
    const navMobileMargin = 20;
    const navMobileIcon = $('.nav-mobile__icon');
    const navMobileList = $('.nav-mobile__list');
    const navMobileListInnerHeight = $('.nav-mobile__list-inner').height();
    const navMobileHeaderHeight = $('.nav-mobile__header').outerHeight(true);
    let navMobileListHeight = navMobileList.height();
    let navMobileListScrollHeight = 0;

    if(navMobileList[0]!==undefined){
        navMobileListScrollHeight = navMobileList[0].scrollHeight;
    }

    if (navMobileListInnerHeight + navMobileHeaderHeight < navMobileListHeight) {
        navMobileIcon.hide();
    }

    navMobileList.scroll(function () {
        let navMobileListScrolled = navMobileList.scrollTop();

        if (navMobileListScrolled >= navMobileListScrollHeight - navMobileListHeight - navMobileMargin) {
            navMobileIcon.hide();

            return;
        }

        navMobileIcon.show();
    });
};
